import React from 'react';
import Link from '../../link';
import webUtils from '../../../utils/webUtils';
import './index.css';

export default function ExtraButton({link, img, text}) {
  const normalizedImg = webUtils.normalizeImageUrl(img);
  return (
    <div className="banner-extra--button">
      {link ? (
        <Link to={link}>
          <img alt="" src={normalizedImg} />
        </Link>
      ) : (
        <div className="banner-extra--button-image">
          <img alt="" src={normalizedImg} />
        </div>
      )}
      <div>{text}</div>
    </div>
  );
}
